import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ThemeContext } from '../../../theme/ThemeProvider';
import { getAllFormDefinitions } from '../../../services/clinicPortalServices/formDefinitionService';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import { Button } from 'react-bootstrap';
import EditBtnCellRenderer from './EditBtnCellRenderer';
import moment from 'moment';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class FormBuilderList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'Actions',
                    minWidth: 200,
                    maxWidth: 200,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Name',
                    minWidth: 200,
                    resizable: true,
                    field: 'name'
                },
                {
                    headerName: 'Entity Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'entityType'
                },
                {
                    headerName: 'Slug',
                    minWidth: 150,
                    resizable: true,
                    field: 'slug'
                },
                {
                    headerName: 'Status',
                    minWidth: 120,
                    resizable: true,
                    field: 'status',
                    cellStyle: (params) => {
                        if (params.value === 'published') return { color: 'green' };
                        if (params.value === 'draft') return { color: 'orange' };
                        if (params.value === 'archived') return { color: 'gray' };
                        return {};
                    }
                },
                {
                    headerName: 'Fields',
                    minWidth: 100,
                    resizable: true,
                    valueGetter: (params) => (params.data.fields ? params.data.fields.length : 0)
                },
                {
                    headerName: 'Global',
                    minWidth: 100,
                    resizable: true,
                    valueGetter: (params) => (params.data.isGlobal ? 'Yes' : 'No')
                },
                {
                    headerName: 'Version',
                    minWidth: 100,
                    resizable: true,
                    field: 'version'
                },
                {
                    headerName: 'Updated',
                    minWidth: 180,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment(params.data.updatedAt).format('MM/DD/YYYY hh:mm A');
                    }
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this }
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.loadGridData();
    };

    loadGridData = () => {
        getAllFormDefinitions().then((res) => {
            this.setState({ rowData: res.data || [] });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    handleEdit = (formDef) => {
        if (this.props.onEditForm) {
            this.props.onEditForm(formDef._id);
        }
    };

    handleCreate = () => {
        if (this.props.onCreateForm) {
            this.props.onCreateForm();
        }
    };

    render() {
        return (
            <div>
                <div className="row" style={{ padding: '15px' }}>
                    <div className="col-md-6">
                        <h2>Form Builder</h2>
                    </div>
                    <div className="col-md-6 text-right">
                        <input
                            type="text"
                            placeholder="Search..."
                            onChange={this.onFilterTextChange}
                            className="form-control d-inline-block"
                            style={{ width: '200px', marginRight: '10px' }}
                        />
                        <Button variant="primary" onClick={this.handleCreate}>
                            <i className="fa fa-plus" /> New Form
                        </Button>
                    </div>
                </div>
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div id="myGrid" style={{ height: '100%', width: '100%' }}>
                                <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default FormBuilderList;
